import React from 'react';
import { Totals } from '../../../../tabs/GainLoss/Components/UnrealizedGainLossTab/components/Totals/Totals';

interface Props {
  title: string;
}

export const UnrealizedGainLossSummaryCard = ({ title }: Props) => {
  return <Totals title={title} />;
};
